import { render } from "./UnderlineButton.vue?vue&type=template&id=aae2cae8"
import script from "./UnderlineButton.vue?vue&type=script&lang=js"
export * from "./UnderlineButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__